import { useCallback } from "react";
import axios from "axios";
import { useConfig } from "../../../../lib/config";
import { useProperty } from "../../../../components/property-provider";

export type OrchestratorCacheResource = "scenarios" | "globalActions" | "segments";

// encodeURIComponent leaves dots untouched, so dot-only segments must be rejected explicitly.
const isDotSegment = (value: string) => /^\.+$/.test(value);

export function useOrchestratorCache() {
  const config = useConfig();
  const { ticker, token } = useProperty();

  const regenCache = useCallback(
    (resource: OrchestratorCacheResource) => {
      if (isDotSegment(ticker)) {
        console.error("Error regenerating orchestrator cache: invalid property ticker");
        return Promise.resolve();
      }

      return axios
        .post(
          `${config.apiEndpoint}/api/orchestrator/cache/${encodeURIComponent(ticker)}/${resource}`,
          {},
          {
            headers: {
              "x-property": ticker,
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        )
        .catch(error => console.error("Error regenerating orchestrator cache", error));
    },
    [config.apiEndpoint, ticker, token]
  );

  return { regenCache };
}
